import React, {useEffect} from 'react';

import {BigLoading} from '../../components/BigLoading'

export const DigitalFront = () => {
  useEffect(() => {
    window.location = `${window.CONFIG.DIGITAL_FRONT}`;
  }, [])
  return (
    <div style={{marginTop: '5rem'}}>
      <BigLoading/>
    </div>
  )
}
